import React, { useEffect, useState } from "react";
import sortBy from "lodash/sortBy";
import Slider, { Settings } from "react-slick";
const Lightbox = React.lazy(() => import("yet-another-react-lightbox"));

import {
  imageCarousel,
  ImagePositionTypes,
  ImageTypes,
} from "@enums/shared.enum";
import { ImageSliderProps, SliderImageType } from "@models/shared/shared.model";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "yet-another-react-lightbox/styles.css";

const ImageSlickSlider: React.FC<ImageSliderProps> = ({
  image,
  speed = imageCarousel.defaultSpeed,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [showLightBox, setShowLightBox] = useState(false);
  const [sortedImages, setSortedImages] = useState<Array<SliderImageType>>([]);

  useEffect(() => {
    setBackGroundAsFirst();
  }, [image]);

  const handleAfterChange = (current: number) => {
    setActiveIndex(current);
  };

  const setBackGroundAsFirst = () => {
    const hasType = image.some(img => img.type !== undefined);

    const sorted = hasType
      ? sortBy(image, img =>
          img.type === ImageTypes.background
            ? ImagePositionTypes.background
            : ImagePositionTypes.slider
        )
      : image;

    setSortedImages(sorted);
  };

  const settings: Settings = {
    accessibility: true,
    afterChange: handleAfterChange,
    dots: true,
    easing: "ease-in-out",
    infinite: true,
    initialSlide: activeIndex,
    lazyLoad: "ondemand",
    slidesToScroll: 1,
    slidesToShow: 1,
    speed,
    touchMove: true,
  };

  return (
    <div className="fg-banner-block" data-testid="slider-container">
      <Slider {...settings}>
        {sortedImages?.map((image: SliderImageType) => {
          return (
            <div className="fg-banner-inner" key={image.name}>
              <img
                src={image.url}
                alt={image.name || "slider image"}
                data-testid={image.source}
                className="fg-slider-image"
              />
            </div>
          );
        })}
      </Slider>
      <button
        onClick={() => {
          setShowLightBox(true);
        }}
        className="lightbox-trigger"
      >
        <img src="/assets/images/lightBox.svg" alt="lightbox trigger" />
      </button>
      <Lightbox
        open={showLightBox}
        close={() => setShowLightBox(false)}
        slides={sortedImages.map((image: SliderImageType) => {
          return { src: image.url };
        })}
        index={activeIndex}
      />
    </div>
  );
};

export default ImageSlickSlider;
